import { createFileRoute } from '@tanstack/react-router'

import {
  UnauthenticatedErrorComponent,
  UnauthenticatedRouteComponent,
} from '@/containers/unauthenticated'

export const Route = createFileRoute('/_unauthenticated')({
  component: UnauthenticatedRouteComponent,
  errorComponent: UnauthenticatedErrorComponent,
})
